/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./name-id.vue?vue&type=template&id=6d055ac5&scoped=true&"
import script from "./name-id.vue?vue&type=script&lang=ts&"
export * from "./name-id.vue?vue&type=script&lang=ts&"
import style0 from "./name-id.vue?vue&type=style&index=0&id=6d055ac5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d055ac5",
  null
  
)

export default component.exports